import ErrorMessage from './errorMessage.js';
import _ from 'lodash';

/**
 *
 * ErrorMessageList
 *
 * @namespace ErrorMessageList
 */
let ErrorMessageList = function(errors) {
    "use strict";

    //Initialize
    this.errorMessages = [];
    this.infoMessages = [];
    if (errors) {
        if ((errors.errorMessages !== undefined && errors.errorMessages !== null) && errors.errorMessages.length > 0) {
            if (errors.errorMessages[0] instanceof ErrorMessage) {
                this.errorMessages = errors.errorMessages;
            } else {
                for (let i = 0; i < errors.errorMessages.length; i++) {
                    let errorMessage = new ErrorMessage(errors.errorMessages[i]);
                    this.errorMessages.push(errorMessage);
                }
            }
        }
        if ((errors.infoMessages !== undefined && errors.infoMessages !== null) && errors.infoMessages.length > 0) {
            if (errors.infoMessages[0] instanceof ErrorMessage) {
                this.infoMessages = errors.infoMessages;
            } else {
                for (let i = 0; i < errors.infoMessages.length; i++) {
                    let errorMessage = new ErrorMessage(errors.infoMessages[i]);
                    this.infoMessages.push(errorMessage);
                }
            }
        }
    }

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.toJSON()
     * @returns {object} errorMessageObject
     */
    this.toJSON = function() {
        let errors = {};
        errors.errorMessages = this.errorMessages;
        errors.infoMessages = this.infoMessages;
        return errors;
    };

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.clearErrors()
     */
    this.clearErrors = function() {
        this.errorMessages = [];
        this.infoMessages = [];
    };

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.hasMessages()
     * @returns {boolean} hasMessages
     */
    this.hasMessages = function() {
        return (this.errorMessages.length > 0 || this.infoMessages.length > 0);
    };

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.hasErrorMessages()
     * @returns {boolean} hasErrorMessages
     */
    this.hasErrorMessages = function() {
        return (this.errorMessages.length > 0);
    };

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.hasErrorsWhichMustBeResolved()
     * @returns {boolean} hasErrorsWhichMustBeResolved
     */
    this.hasErrorsWhichMustBeResolved = function() {
        let total = 0;

        if (this.errorMessages && this.errorMessages.length > 0) {
            total = _.reduce(this.errorMessages, function(count, error) {
                return count + (error.mustResolve ? 1 : 0);
            }, 0);
        }

        return (total > 0);
    };

    /**
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.hasInfoMessages()
     * @returns {boolean} hasInfoMessages
     */
    this.hasInfoMessages = function() {
        return (this.infoMessages.length > 0);
    };

    /**
     * Add error message to the specified list
     * @memberof ErrorMessageList
     * @example
     * ErrorMessageList.addErrorMessage(type, errorMessage)
     * @param type
     * @param errorMessage
     */
    this.addErrorMessage = function(type, errorMessage) {
        switch (type) {
            case "error":
                if (errorMessage instanceof ErrorMessage) {
                    this.errorMessages.push(errorMessage);
                } else {
                    this.errorMessages.push(new ErrorMessage(errorMessage));
                }
                break;
            case "info":
                if (errorMessage instanceof ErrorMessage) {
                    this.infoMessages.push(errorMessage);
                } else {
                    this.infoMessages.push(new ErrorMessage(errorMessage));
                }
                break;
            default:
                if (errorMessage instanceof ErrorMessage) {
                    this.errorMessages.push(errorMessage);
                } else {
                    this.errorMessages.push(new ErrorMessage(errorMessage));
                }
        }
    };
};

export default ErrorMessageList;
